<!-- </div> -->
<div class="card h-100" id="exam_start_card" role="region" aria-labelledby="examinationListTitle">
  <!-- Card header -->
  <div class="card-header">
    <app-language-layout></app-language-layout>
    <!-- Title -->
    <h5 id="examinationListTitle" class="h3 mb-0">{{language.examinationList}}</h5>

  </div>
  <!-- Card body -->
  <div class="card-body">
    <!-- List group -->
    <div class="col-md-12" aria-labelledby="scheduledExamsHeading">
      <!-- Card header -->
      <div class="card-title">
        <!-- remove border-0 -->
        <div class="d-flex justify-content-between mt-3">
          <h3 id="scheduledExamsHeading" class="mb-0">{{language.scheduledExaminations}}</h3>
          <a class="complaint" routerLink="/complaint"><b>{{language.makeComplaint}}</b></a>
        </div>
      </div>

      <!-- Light table -->
      <div *ngIf="exams && exams.length>0" class="card-body" role="list">
        <div class="row">
          <div class="col-sm-12 exam-type-sec">
            <div class="my-2">
              <div class="classmaterial" *ngFor="let exam of exams" role="listitem">
                <app-userexamination class="mt-5" [exam]="exam" (destroyInterval)="destroyInterval($event)"
                  (resumeInterval)="resumeInterval($event)"></app-userexamination>
                <div class="mt-5"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="exams && exams.length==0" role="alert" aria-live="polite">
        {{language.noExamsFound}}
      </div>

    </div>
  </div>
</div>

